import "./buttons.scss";

import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PersonalizeLater = ({ handleClick }) => {
  return (
    <p className="btn-text-blue base navigate" onClick={handleClick}>
      <strong>
        Personalize account later
        <FontAwesomeIcon icon={faChevronRight} />
      </strong>
    </p>
  );
};

export default PersonalizeLater;
